import React from 'react'
import { ComingSoon } from '../../../Components'

export default function Invitations() {
    return (
        <div>
            <ComingSoon />
        </div>
    )
}
